import { createActionCreator } from 'reducers/utils/helpers';
import {
  playbookContent,
  filtersById,
  shareUrl,
  clearShareUrl as clearShareUrlType,
} from './types';

export const requestPlaybookContent = createActionCreator(playbookContent.request, 'playbookId');
export const requestPlaybookContentSuccess = createActionCreator(
  playbookContent.success,
  'playbookId',
  'response',
);
export const requestPlaybookContentFailure = createActionCreator(
  playbookContent.failure,
  'playbookId',
  'error',
);

export const requestFiltersById = createActionCreator(filtersById.request, 'filtersId');
export const requestFiltersByIdSuccess = createActionCreator(
  filtersById.success,
  'filtersId',
  'response',
);
export const requestFiltersByIdFailure = createActionCreator(
  filtersById.failure,
  'filtersId',
  'error',
);

export const clearShareUrl = createActionCreator(clearShareUrlType);
export const requestShareUrl = createActionCreator(shareUrl.request, 'payload');
export const requestShareUrlSuccess = createActionCreator(shareUrl.success, 'payload', 'response');
export const requestShareUrlFailure = createActionCreator(shareUrl.failure, 'payload', 'error');
